import React, { FC } from 'react';
import { useT } from '@hooks';
import styled from 'styled-components';
import { Title } from '../title';
import checkTheme from 'utils/custom/checkTheme';
import img1 from './img/img1.png';
import img2 from './img/img2.png';
import img3 from './img/img3.png';
import img4 from './img/img4.png';
import img5 from './img/img5.png';
import img6 from './img/img6.png';
import img1d from './img/img1d.png';
import img2d from './img/img2d.png';
import img3d from './img/img3d.png';
import img4d from './img/img4d.png';
import img5d from './img/img5d.png';

const Container = styled.div``;

const Subtitle = styled.p`
	color: ${({ theme }) => theme.colors.text11};
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 15px;
	margin-top: 8px;
`;

const Description = styled.p`
	color: ${({ theme }) => theme.colors.text11};
	text-align: center;
	font-size: 15px;
	font-weight: 700;
	line-height: 20px;
	margin-top: 20px;
`;

const Items = styled.div`
	margin-top: 16px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 12px;
`;

const Item = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 12px;
	color: ${({ theme }) => theme.colors.text11};
	font-size: 15px;
	font-weight: 400;
	line-height: 20px;
`;

const ImgWrapper = styled.div`
	border-radius: 50%;
	background: rgba(214, 210, 234, 0.3);
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 24px;
	}
`;

const TextWrapper = styled.div`
	p:first-child {
		font-weight: 700;
		line-height: 22px;
	}
`;

const Info = styled.div`
	color: ${({ theme }) => theme.colors.text11};
	font-size: 12px;
	font-weight: 600;
	line-height: 15px;
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg12};
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-top: 20px;

	img {
		width: 32px;
	}
`;

export const Benefits: FC = props => {
	const { T } = useT();

	const benefitsItems = [
		{
			img: checkTheme() === 'darkMode' ? img1d : img1,
			title: 'Access to a library',
			text: 'of over 1000 trainer-approved exercises and guided workouts with detailed video tutorials',
		},
		{
			img: checkTheme() === 'darkMode' ? img2d : img2,
			title: 'A comprehensive approach',
			text: 'combining cardio, strength, and recovery workouts for optimal results.',
		},
		{
			img: checkTheme() === 'darkMode' ? img3d : img3,
			title: 'A daily meal plan',
			text: 'to support your training goals, including healthy lifestyle recipes.',
		},
		{
			img: checkTheme() === 'darkMode' ? img4d : img4,
			title: 'A variety of workout types',
			text: 'to keep your routine engaging and enjoyable, including fitness, yoga, walking/running, dancing and more',
		},
		{
			img: checkTheme() === 'darkMode' ? img5d : img5,
			title: 'A package of Mental Health tools',
			text: 'including Meditation, Sleep waves and melodies, Motivation and Relax sounds',
		},
	];

	return (
		<Container>
			<Title>Highlights of your plan</Title>
			<Subtitle>
				Based on your goals and personal data, our intelligent algorithm will provide a customized
				workout plan designed to help you achieve optimal results.
			</Subtitle>
			<Description>To help you reach your goals, you will receive:</Description>
			<Items>
				{benefitsItems.map((item, index) => (
					<Item key={index}>
						<ImgWrapper>
							<img src={item.img} alt={item.title} />
						</ImgWrapper>
						<TextWrapper>
							<p>{item.title}</p>
							<p>{item.text}</p>
						</TextWrapper>
					</Item>
				))}
			</Items>
			<Info>
				<img src={img6} alt='info' />
				<p>All features conveniently accessible in a single mobile app on your device</p>
			</Info>
		</Container>
	);
};
